import { Outlet } from 'react-router-dom'
import { BehaviorRouteTracker } from '@/analytics/BehaviorRouteTracker'

/**
 * Root layout — wraps all routes so we can track every page view and route change.
 */
export function RootLayout() {
  return (
    <>
      <BehaviorRouteTracker />
      <Outlet />
    </>
  )
}
